import styled from 'styled-components';
import { Spacing8 } from 'autogen/design-tokens/tokens';
import Flex from 'components/Layout/components/Flex';
import FilterListItem from 'components/List/components/FilterListItem';
import Checkbox from 'components/shared/inputs/checkbox';
import useGA4Tracking from 'modules/tracking/GA4';
import useFilters from '../../../shared/hooks/useFilters';
import { HitCount } from '../shared/styles';
import type { ColorFilterOptionProps } from '../shared/types';

const ColorPreview = styled.div<{ hexColor?: string }>`
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: ${({ hexColor }) => hexColor || 'transparent'};
`;

export default function ColorFilterOption({
    model: { displayName, hitCount, isDisabled, value, hexColor },
    queryStringName,
    menuDisplayName
}: ColorFilterOptionProps) {
    const ga4Tracking = useGA4Tracking();
    const { togglePendingFilterByValue, isPendingFilterValueActive } = useFilters();

    if (isDisabled) return null;

    const isSelected = isPendingFilterValueActive(queryStringName, value);

    const beforeSlot = <ColorPreview hexColor={hexColor} />;

    return (
        <FilterListItem.Button
            type="multi select"
            isSelected={isSelected}
            count={hitCount}
            buttonProps={{
                onClick: () => {
                    togglePendingFilterByValue(queryStringName, value);
                    ga4Tracking({
                        eventName: 'select_filter',
                        category: 'ecommerce',
                        eventParams: [
                            { param_name: 'list_name', param_value: displayName },
                            { param_name: 'filter_name', param_value: value },
                            { param_name: 'filter_list_name', param_value: menuDisplayName }
                        ]
                    });
                }
            }}
            BeforeRenderer={() => beforeSlot}
        >
            {displayName}
        </FilterListItem.Button>
    );
}
